import styled from 'styled-components';

export const Input = styled.input`
	width: 100%;
	border: 0;
	border-bottom: 1px dashed var(--background);
	font-size: inherit;
`;
